<template>
  <div :style="maxHeight" style="overflow-y: auto;overflow-x: hidden">

    <div style="margin-left: 40px">
      <el-button v-if="this.parentData" type="success" :loading="loading" @click="deleteChartData">{{"数据修复"}}</el-button>
      <el-button type="primary">{{"物件选择"}}</el-button>
      <el-select v-model="wuJianId" clearable @change="renderAllEcharts" placeholder="物件选择" style="width: 200px;">
        <el-option
            v-for="item in wuJianNames"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>
      <el-select v-model="supplier" @change="renderAllEcharts" clearable placeholder="供应商" style="width: 200px;">
        <el-option
            v-for="item in suppliers"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>
    </div>

    <el-row style="height: 45%">
      <el-col :span="12" style="border-right: 8px solid whitesmoke;border-bottom: 8px solid whitesmoke;height: 100%">
        <div class="title">{{'物件别玻璃不良推移'}}
        </div>
        <div v-loading="wuJianChartLoading" element-loading-text="数据加载中" style="width: 100%;height: 90%" id="wuJian"/>
      </el-col>
      <el-col :span="12" style="border-bottom: 8px solid whitesmoke;height: 100%">
        <div class="title">
          <span>{{'不良项目数量占比'}}</span>
          <div class="space-between">
            <el-select v-model="pieDate.badType" @change="getPieChart" size="small" style="width: 90px;margin-right: 10px">
              <el-option
                  v-for="item in badTypes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
            <el-date-picker v-model="pieDate.year" @change="getPieChart" format="YYYY 年" value-format="YYYY" clearable type="year" placeholder="年" style="width: 80px; margin-right: 10px" size="small"/>
            <el-date-picker v-model="pieDate.month" @change="getPieChart" format="MM 月" value-format="MM" clearable type="month" placeholder="月" style="width: 70px; margin-right: 10px" size="small"/>
            <!--              <el-date-picker v-model="pieDate.day" @change="getPieChart" format="DD 日" value-format="DD" clearable type="day" placeholder="日" style="width: 70px;" size="small"/>-->
          </div>
        </div>
        <div v-loading="pieChartLoading" element-loading-text="数据加载中" style="width: 100%;height: 90%" id="pie"/>
      </el-col>
    </el-row>

    <el-row style="height: 45%">
      <el-col :span="12" style="border-right: 8px solid whitesmoke;border-bottom: 8px solid whitesmoke;height: 100%">
        <div class="title">
          <span>{{'日不良率'}}</span>
          <el-date-picker v-model="dayBad.dateDay" @change="getDayChart" format="YYYY 年 M 月" value-format="YYYY-M-1" type="month" placeholder="选择月份" style="width: 130px" size="small"/>
        </div>
        <div v-loading="dayBadLoading" element-loading-text="数据加载中" style="width: 100%;height: 90%" id="dayBad"/>
      </el-col>
      <el-col :span="12" style="border-bottom: 8px solid whitesmoke;height: 100%">
        <div class="title">
          {{'受入玻璃不良堆积图'}}
          <div class="space-between">
            <el-select v-model="drumDate.badType" @change="getDrumChart" size="small" style="width: 90px;margin-right: 10px">
              <el-option
                  v-for="item in badTypes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
            <el-date-picker v-model="drumDate.year" @change="getDrumChart" format="YYYY 年" value-format="YYYY" clearable type="year" placeholder="年" style="width: 80px; margin-right: 10px" size="small"/>
            <el-date-picker v-model="drumDate.month" @change="getDrumChart" format="MM 月" value-format="MM" clearable type="month" placeholder="月" style="width: 70px; margin-right: 10px" size="small"/>
            <!--              <el-date-picker v-model="drumDate.day" @change="getPieChart" format="DD 日" value-format="DD" clearable type="day" placeholder="日" style="width: 70px;" size="small"/>-->
          </div>
        </div>
        <div v-loading="drumChartLoading" element-loading-text="数据加载中" style="width: 100%;height: 90%" id="drumBoli"/>
      </el-col>
    </el-row>

    <el-row style="height: 45%">
      <el-col :span="12" style="border-right: 8px solid whitesmoke;border-bottom: 8px solid whitesmoke;height: 100%">
        <div class="title">
          {{'种类别玻璃不良推移'}}
          <div class="space-between">
            <el-date-picker v-model="glassTypeBad.year" @change="getBlendChart" format="YYYY 年" value-format="YYYY" clearable type="year" placeholder="年" style="width: 80px; margin-right: 10px" size="small"/>
            <el-select v-model="glassTypeBad.glassType" @change="getBlendChart" clearable placeholder="总不良率" size="small" style="width: 90px">
              <el-option
                  v-for="item in glassTypes"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div v-loading="blendChartLoading" element-loading-text="数据加载中" style="width: 100%;height: 90%" id="blend"/>
      </el-col>
      <el-col :span="12" style="border-bottom: 8px solid whitesmoke;height: 100%">
        <div class="title">
          {{'受入玻璃责任推移'}}
          <div class="space-between">
            <el-date-picker v-model="reproach.year" @change="getReproachChart" format="YYYY 年" value-format="YYYY" clearable type="year" placeholder="年" style="width: 80px; margin-right: 10px" size="small"/>
          </div>
        </div>
        <div v-loading="reproachChartLoading" element-loading-text="数据加载中" style="width: 100%;height: 90%" id="selfReproach"/>
      </el-col>
    </el-row>

    <el-row style="height: 45%">
      <el-col :span="12" style="border-right: 8px solid whitesmoke;border-bottom: 8px solid whitesmoke;height: 100%">
        <div class="title">
          {{'玻璃检查产量'}}
          <div class="space-between">
            <el-date-picker v-model="classDate.year" @change="getClassDrumChart" format="YYYY 年" value-format="YYYY" clearable type="year" placeholder="年" style="width: 80px; margin-right: 10px" size="small"/>
            <el-date-picker v-model="classDate.month" @change="getClassDrumChart" format="MM 月" value-format="MM" clearable type="month" placeholder="月" style="width: 70px; margin-right: 10px" size="small"/>
          </div>
        </div>
        <div v-loading="classChartLoading" element-loading-text="数据加载中" style="width: 100%;height: 90%" id="classBl"/>
      </el-col>
      <el-col :span="12" style="border-bottom: 8px solid whitesmoke;height: 100%">
      </el-col>
    </el-row>

    <KfDialog v-model="dialogVisible" :item="dialogItem">

      <template #footer>
        <div style="display: flex;flex-direction: column;align-items: center;justify-content: space-around;">
          <div style="width:100%; display: flex;flex-direction: row;align-items: center;justify-content: space-around;">
            <span style="font-size: 24px;">{{this.chartData.name}}</span>
            <el-input-number v-model="this.chartData.value"/>
          </div>
          <el-button style="margin-top: 20px" type="primary" @click="editChartData">{{"保存"}}</el-button>
        </div>
      </template>
    </KfDialog>

    <KfDialog v-model="infoDialog" :item="dialogItem">

      <template #footer>
            <el-table v-loading="this.infoLoading" :data="this.dataInfo['bus_shouru_boli_item']" height="350" style="width: 100%;">
              <el-table-column prop="wujian_id" label="物件番号" width="120" />
              <el-table-column prop="glasspiece_no" label="玻璃号" width="150" />
              <el-table-column prop="boli_check_item" label="检查项" min_width="150">
                {{this.checkItemName}}
              </el-table-column>
              <el-table-column prop="create_time" label="检查时间" width="250" align="center"/>
              <el-table-column fixed="right" prop="result"  label="结果" width="120">
                <template #default="scope">
                  <div v-if="scope.row.result === 'recheck_false'">{{"重检不合格"}}</div>
                  <div v-if="scope.row.result === 'recheck_true'">{{"重检合格"}}</div>
                  <div v-if="scope.row.result === 'false'">{{"不合格"}}</div>
                </template>
              </el-table-column>
            </el-table>
      </template>
    </KfDialog>
  </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
  name: "ShouRuBoLiPage",
  props: ['parentData'],
  data(){
    return{
      maxHeight:'',
      infoLoading:false,
      dataInfo:{},
      checkItemName:'',
      infoDialog:false,
      dialogVisible:false,
      loading:false,
      dialogItem:{
        title:'',
        width:'30%'
      },
      chartData:{},
      dayBad:{
        dateDay:this.getDateFormat()
      },
      pieDate:{
        year:this.$common.getCurrentYearByMonth().toString(),
        month:this.$common.getDateLabel(new Date().getUTCMonth() + 1),
        day:'',
        badType:'false'
      },
      badTypes:[
        {label:"一次不良",value:"false"},
        {label:"二次不良",value:"recheck_false"},
      ],
      drumDate:{
        year:this.$common.getCurrentYearByMonth().toString(),
        month:this.$common.getDateLabel(new Date().getUTCMonth() + 1),
        badType:'false'
        /*day:''*/
      },
      glassTypeBad:{
        glassType:'',
        year:this.$common.getCurrentYearByMonth().toString(),
      },
      glassTypes:[],
      reproach:{
        year:this.$common.getCurrentYearByMonth().toString(),
      },
      wuJianId:'',
      supplier:'',
      wuJianNames:[],
      suppliers:[],
      supplierBad:{
        supplier:'',
        year:this.$common.getCurrentYearByMonth().toString(),
      },
      /*不良项目数量占比*/
      optionPie:{
        type:'pie_chart',
        title: {
          text: '总数量',
          top: '37%',
          left: '49%',
          textAlign: 'center',
          textStyle: {
            color: 'black',
            fontSize: '20px',
            lineHeight: 30
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: "{b} : {c} ({d}%)"
        },
        legend: {
          type: 'scroll',
          orient: 'horizontal',
          data: [
            { value: 1048, name: '二次胶不良' },
            { value: 735, name: '内脏' },
            { value: 580, name: '开裂' },
            { value: 484, name: '变形' },
            { value: 84, name: '擦伤,划伤' },
            { value: 44, name: '膜不良' },
            { value: 84, name: '爆边,爆角' },
            { value: 84, name: 'PVB不良' },
            { value: 44, name: '结石' },
            { value: 44, name: '叠差' },
            { value: 44, name: '表面凹坑' },
            { value: 44, name: '无应力' },
            { value: 44, name: '氩气不足' },
            { value: 300, name: '实物与标签不符' }
          ],
          top:0
        },
        series: [
          {
            name: '不良项目',
            type: 'pie',
            radius: ['40%', '65%'],
            center: ['50%', '50%'],
            label:{
              show: true,
              formatter: '{b},{d}%'
            },
            data: [
              { value: 44, name: '无应力' },
              { value: 84, name: '擦伤,划伤' },
              { value: 1048, name: '二次胶不良' },
              { value: 44, name: '膜不良' },
              { value: 735, name: '内脏' },
              { value: 44, name: '氩气不足' },
              { value: 84, name: 'PVB不良' },
              { value: 580, name: '开裂' },
              { value: 44, name: '叠差' },
              { value: 484, name: '变形' },
              { value: 44, name: '结石' },
              { value: 84, name: '爆边,爆角' },
              { value: 300, name: '实物与标签不符' },
              { value: 44, name: '表面凹坑' },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      },
      pieChartLoading:false,
      /*物件别玻璃不良推移*/
      wujianQuery:{},
      optionWuJian: {
        type:'wujian_chart',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          //data: ['Evaporation', 'Precipitation', 'Temperature']
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '不良数量',
            min:0,
            max:100,
            interval:20,
            axisLabel: {
              formatter: '{value}'
            }
          },
          {
            type: 'value',
            name: '不良率',
            min:0,
            max:10,
            interval:2,
            axisLabel: {
              formatter: function (value){
                return value.toFixed(1) + '%'
              }
            }
          }
        ],
        series: [
          {
            name: '一次不良',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: '二次不良',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: '自责',
            type: 'bar',
            color:'#73c0de',
            data: []
          },
          {
            name: '目标',
            type: 'line',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + '%';
              }
            },
            data: []
          },
          {
            name: '实绩',
            type: 'line',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + '%';
              }
            },
            data: []
          }
        ],
        dataZoom:[
          {
            start: 0,
            end: 100,//默认为100
            type: 'slider',
            show: true,
            // xAxisIndex: [0],
            handleSize: 0,//滑动条的 左右2个滑动条的大小
            startValue: null, // 初始显示值
            endValue: null, // 结束显示值
            height: 15,//组件高度
            left: '5%', //左边的距离
            right: '4%',//右边的距离
            borderRadius: 5,
            showDataShadow: false,//是否显示数据阴影 默认auto
            showDetail: true,//即拖拽时候是否显示详细数值信息 默认true
            realtime: false, //是否实时更新
            filterMode: 'filter',
          },
          //下面这个属性是里面拖到
          {
            type: 'inside',
            show: true,
            // xAxisIndex: [0],
            start: 1,//默认为1
            end: 100,//默认为100
          },
        ]
      },
      wuJianChartLoading:false,
      wuJianTarget:0,
      /*供应商别玻璃不良推移*/
      optionSupplier: {
        type:'supplier_chart',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          //data: ['Evaporation', 'Precipitation', 'Temperature']
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '不良数量',
            min:0,
            max:100,
            interval:20,
            axisLabel: {
              formatter: '{value}'
            }
          },
          {
            type: 'value',
            name: '不良率',
            min:0,
            max:10,
            interval:2,
            axisLabel: {
              formatter: function (value){
                return value.toFixed(1) + '%'
              }
            }
          }
        ],
        series: [
          {
            name: '一次不良',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: [

            ]
          },
          {
            name: '二次不良',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: [

            ]
          },
          {
            name: '目标',
            type: 'line',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + '%';
              }
            },
            data: []
          },
          {
            name: '实绩',
            type: 'line',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + '%';
              }
            },
            data: []
          }
        ]
      },
      supplierChartLoading:false,
      supplierTarget:0,
      /*玻璃不良堆积图*/
      optionDrum: {
        type:'drum_chart',
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            let res = `${params[0].name} <br/>`
            for (const item of params) {
              if (item.value !== 0) {
                res += `<span style="background: ${item.color}; height:10px; width: 10px; border-radius: 50%;display: inline-block;margin-right:10px;"></span> ${item.seriesName} : ${item.value}<br/>`
              }
            }
            return res
          },
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
            type: 'scroll',            // 设置图例翻页
            orient: 'horizontal',     // 图例横向排布
            data: [],              // title是一个列表，存着图例的数据
        },
        grid: {
          left: '8%',
          right: '8%',
          bottom: '8%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: [2109, 2110, 2111, 2112, 2201, 2202, 2203]
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '不良数量',
            max: function (value) {
              return value.max + 20;
            }
          }
        ],
        series: [
          {
            name: '无应力',
            type: 'bar',
            emphasis: {
              focus: 'series'
            },
            data: [320, 332, 301, 334, 390, 330, 320]
          },
          {
            name: '擦伤,划伤',
            type: 'bar',
            stack: 'Ad',
            emphasis: {
              focus: 'series'
            },
            data: [120, 132, 101, 134, 90, 230, 210]
          },
          {
            name: '二次胶不良',
            type: 'bar',
            stack: 'Ad',
            emphasis: {
              focus: 'series'
            },
            data: [220, 182, 191, 234, 290, 330, 310]
          },
          {
            name: '膜不良',
            type: 'bar',
            stack: 'Ad',
            emphasis: {
              focus: 'series'
            },
            data: [150, 232, 201, 154, 190, 330, 410]
          },
          {
            name: '内脏',
            type: 'bar',
            data: [862, 1018, 964, 1026, 1679, 1600, 1570],
            emphasis: {
              focus: 'series'
            },
            markLine: {
              lineStyle: {
                type: 'dashed'
              },
              data: [[{ type: 'min' }, { type: 'max' }]]
            }
          },
          {
            name: '氩气不足',
            type: 'bar',
            barWidth: 5,
            stack: 'Ad',
            emphasis: {
              focus: 'series'
            },
            data: [60, 73, 71, 74, 100, 130, 120]
          },
          {
            name: 'PVB不良',
            type: 'bar',
            stack: 'Search Engine',
            emphasis: {
              focus: 'series'
            },
            data: [120, 132, 101, 134, 290, 230, 220]
          },
          {
            name: '开裂',
            type: 'bar',
            stack: 'Search Engine',
            emphasis: {
              focus: 'series'
            },
            data: [60, 72, 71, 74, 190, 130, 110]
          },
          {
            name: '叠差',
            type: 'bar',
            stack: 'Search Engine',
            emphasis: {
              focus: 'series'
            },
            data: [62, 82, 91, 84, 109, 110, 120]
          },
          {
            name: '变形',
            type: 'bar',
            stack: 'Search Engine',
            emphasis: {
              focus: 'series'
            },
            data: [62, 82, 91, 84, 109, 110, 120]
          },
          {
            name: '结石',
            type: 'bar',
            stack: 'Search Engine',
            emphasis: {
              focus: 'series'
            },
            data: [62, 82, 91, 84, 109, 110, 120]
          },
          {
            name: '爆边,爆角',
            type: 'bar',
            stack: 'Search Engine',
            emphasis: {
              focus: 'series'
            },
            data: [62, 82, 91, 84, 109, 110, 120]
          },
          {
            name: '实物与标签不符',
            type: 'bar',
            stack: 'Search Engine',
            emphasis: {
              focus: 'series'
            },
            data: [62, 82, 91, 84, 109, 110, 120]
          },
          {
            name: '表面凹坑',
            type: 'bar',
            stack: 'Search Engine',
            emphasis: {
              focus: 'series'
            },
            data: [62, 82, 91, 84, 109, 110, 120]
          }
        ]
      },
      drumChartLoading:false,
      /*班别堆积图*/
      optionClassDrum: {
        type:'classDrum_chart',
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            let res = `${params[0].name} <br/>`
            for (const item of params) {
              if (item.value !== "0") {
                res += `<span style="background: ${item.color}; height:10px; width: 10px; border-radius: 50%;display: inline-block;margin-right:10px;"></span> ${item.seriesName} : ${item.value}<br/>`
              }
            }
            return res
          },
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          type: 'scroll',
          orient: 'horizontal',
          data: [],
        },
        grid: {
          left: '5%',
          right: '5%',
          bottom: '8%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: []
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '产量'
          }
        ],
        series: []
      },
      classChartLoading:false,
      classDate:{
        year:this.$common.getCurrentYearByMonth().toString(),
        month:this.$common.getDateLabel(new Date().getUTCMonth() + 1),
        /*day:''*/
      },
      /*种类别玻璃不良推移*/
      optionBlend: {
        type:'type_chart',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          //data: ['Evaporation', 'Precipitation', 'Temperature']
        },
        grid: {
          left: '10%',
          right: '10%',
          bottom: '15%',
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '不良数量',
            min:0,
            max:100,
            interval:20,
            axisLabel: {
              formatter: '{value}'
            }
          },
          {
            type: 'value',
            name: '不良率',
            min: 0,
            max: 10,
            interval: 2,
            axisLabel: {
              formatter: function (value){
                return value.toFixed(1) + '%'
              }
            }
          }
        ],
        series: [
          {
            name: '二次不良',
            type: 'bar',
            color:'#91cc75',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: [

            ]
          },
          {
            name: '目标',
            type: 'line',
            color:'#fac858',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + '%';
              }
            },
            data: []
          },
          {
            name: '实绩',
            type: 'line',
            color:'#ee6666',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + '%';
              }
            },
            data: []
          }
        ]
      },
      blendChartLoading:false,
      blendTarget:0,
      /*日不良率*/
      optionDayBad: {
        type:'day_chart',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
        },
        grid: {
          left: '5%',
          right: '10%',
          bottom: '15%',
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '日不良数量',
            min:0,
            max:100,
            interval:20,
            axisLabel: {
              formatter: '{value}'
            }
          },
          {
            type: 'value',
            name: '日不良率',
            min:0,
            max:15,
            interval:3,
            axisLabel: {
              formatter: function (value){
                return value.toFixed(1) + '%'
              }
            }
          }
        ],
        series: [
          {
            name: '一次不良',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: [

            ]
          },
          {
            name: '日不良率',
            type: 'line',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + ' %';
              }
            },
            data: [

            ]
          }
        ]
      },
      dayBadLoading:false,
      /*自责他责推移*/
      optionReproach: {
        type:'reproach_chart',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          //data: ['Evaporation', 'Precipitation', 'Temperature']
        },
        grid: {
          left: '10%',
          right: '10%',
          bottom: '15%',
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '数量',
            min:0,
            max:100,
            axisLabel: {
              formatter: '{value}'
            }
          }
        ],
        series: [
          {
            name: '他责',
            type: 'bar',
            stack: 'Ad',
            color:'#fac858',
            emphasis: {
              focus: 'series'
            },
            data: []
          },
          {
            name: '自责',
            type: 'bar',
            stack: 'Ad',
            color:'#ed6766',
            emphasis: {
              focus: 'series'
            },
            data: []
          },
        ]
      },
      reproachChartLoading:false,
    }
  },
  methods: {
    getMaxHeight() {
      let pageHeight = document.body.scrollHeight -160;
      this.maxHeight = "height: "+pageHeight+"px;";
    },
    getDateFormat(){
      let month = new Date().getMonth() + 1
      return new Date().getUTCFullYear().toString() + "-" + month.toString() + "-1"
    },

    renderEcharts(id,option){
      if (document.getElementById(id)) {
        echarts.init(document.getElementById(id)).dispose();
        let chart = echarts.init(document.getElementById(id));
        chart.setOption(option)
        /*let time*/
       /* //chart绑定滚动事件
        chart.on('dataZoom',function (params) {
          //滚动条事件添加防抖
          clearTimeout(time)
          time = setTimeout(()=>{
            _this.getWuJianChartData(params)
          },1000)
        })*/
        let _this = this
        if (id === 'drumBoli') {
          chart.on('legendselectchanged', function (params) {
            if (params.name === "全部") {
              for (let item in params.selected) {
                params.selected[item] = params.selected['全部']
              }
              option.legend.selected = params.selected
              // chart.clear()
              chart.setOption(option)
            }
          })
        }

        if (id === 'pie') {
          chart.on('legendselectchanged', function (params) {
            let array = []
            option.series[0].data.map((item)=>{
              if (params.selected[item.name]){
                array.push(item)
              }
            })
            option.legend.selected = params.selected
            option.title.text = "合计\n" + _this.$common.getPieSum(array)
            // chart.clear()
            chart.setOption(option)
          })
        }

        chart.on('click', function (params) {
          if (_this.parentData) {
            _this.dialogVisible = true
            _this.chartData.seriesName = params.seriesName
            _this.chartData.value = params.value
            _this.chartData.name = params.name
            _this.chartData.dataIndex = params.dataIndex
            _this.chartData.seriesIndex = params.seriesIndex
            _this.chartData.chartType = option.type
          }else {
            let query = {}
            query.wujian_id = _this.wuJianId
            query.supplier = _this.supplier
            query.type = option.type
            query.seriesName = params.seriesName
            if ("pie_chart" === option.type){
              query.pieDate = _this.pieDate
              query.name = params.data.itemId
              _this.checkItemName = params.name
            }
            if ("drum_chart" === option.type){
              query.drumDate = _this.drumDate
              query.name = params.name
              query.value = params.value
              query.check_item_id = params.check_item_id
              _this.checkItemName = params.seriesName
            }
            if (option.type === 'pie_chart' || 'drum_chart' === option.type) {
              _this.getDataInfo(query)
              _this.dialogItem.width = '60%'
              _this.infoDialog = true
            }
          }
          _this.dialogItem.title = params.seriesName + '-' + params.name
        })
      }
    },

    renderAllEcharts(){
      this.getWuJianChart()
      this.getDayChart()
      this.getBlendChart()
      this.getPieChart()
      //this.getSupplierChart()
      this.getDrumChart()
      this.getReproachChart()
      this.getClassDrumChart()
    },

    async getDataInfo(query){
      this.infoLoading = true
      let {data:res} = await this.$axios.post('/bus/shouRuBoLi/getDataInfo',query);
      this.dataInfo = res.data
      this.infoLoading = false
    },

    async deleteChartData(){
      this.loading = true
      let {data: res} = await this.$axios.post('bus/homePage/deleteChartData',"bus_shouruboli_page");
      if (res.code !== 0) {
        this.$message.error('刷新失败！请重试')
      }else {
        this.$message.success('刷新成功！')
        this.renderAllEcharts()
      }
      this.loading = false
    },

    async editChartData(){
      switch (this.chartData.chartType){
        case "wujian_chart":
          this.wujianQuery.wujian_id = this.wuJianId
          this.chartData.query = this.wujianQuery
        break
        case "pie_chart":
          this.pieDate.wujian_id = this.wuJianId
          this.pieDate.field = this.pieDate.badType
          this.chartData.query = this.pieDate
        break
        case "supplier_chart":
          this.supplierBad.wujian_id = this.wuJianId
          this.supplierBad.field = this.supplierBad.supplier
          this.chartData.query = this.supplierBad
          break
        case "drum_chart":
          this.drumDate.wujian_id = this.wuJianId
          this.drumDate.field = this.drumDate.badType
          this.chartData.query = this.drumDate
          break
        case "classDrum_chart":
          this.classDate.wujian_id = this.wuJianId
          this.chartData.query = this.classDate
          break
        case "type_chart":
          this.glassTypeBad.wujian_id = this.wuJianId
            this.glassTypeBad.field = this.glassTypeBad.glassType
          this.chartData.query = this.glassTypeBad
          break
        case "day_chart":
          this.dayBad.wujian_id = this.wuJianId
          this.chartData.query = this.dayBad
          break
        case "reproach_chart":
          this.reproach.wujian_id = this.wuJianId
          this.chartData.query = this.reproach
          break
      }
      this.chartData.model = "bus_shouruboli_page"
      this.chartData.dataKey = this.$common.getChartDataKey(this.chartData)
      let {data: res} = await this.$axios.post('bus/homePage/editChartData',this.chartData);
      if (res.code !== 0) {
        this.$message.error('修改失败！请重试')
      }else {
        this.$message.success('修改成功！')
        this.dialogVisible = false
      }
      switch (this.chartData.chartType){
        case "wujian_chart":
          await this.getWuJianChart()
          break
        case "pie_chart":
          await this.getPieChart()
          break
        case "supplier_chart":
          await this.getSupplierChart()
          break
        case "drum_chart":
          await this.getDrumChart()
          break
        case "classDrum_chart":
          await this.getClassDrumChart()
          break
        case "type_chart":
          await this.getBlendChart()
          break
        case "day_chart":
          await this.getDayChart()
          break
        case "reproach_chart":
          await this.getReproachChart()
          break
      }

    },

    async getSuppliers() {
      this.supplierBad.supplier = ''
      let search = {
        wujian_id:this.wuJianId,
        method_param_prefix__0:'bus_boli_zhijian_info.supplier_name'
      }
      let {data: res} = await this.$axios.post('bus/datasource/getBoLiSupplier',search);
      if (res.code !== 0) {
        this.$message.error('获取供应商失败')
        return;
      }
      this.suppliers = res.data;
      for (let i = this.suppliers.length - 1; i >= 0 ; i--) {
        if (this.suppliers[i].value === "苏州凯朗德金属科技有限公司" || this.suppliers[i].value === "苏州腾研精密机械有限公司" || this.suppliers[i].value === "苏州市瑞林压铸模具厂"){
          this.suppliers.splice(i,1)
        }
      }
    },

    async getGlassTypeDict() {
      let {data: res} = await this.$axios.post('bus/datasource/getDictList','boli_type');
      if (res.code !== 0) {
        this.$message.error('获取【玻璃类型】失败')
        return;
      }
      res.data.forEach((item)=>{
        if (item.id === "boli_type_pt" || item.id === "boli_type_jc" || item.id === "boli_type_zk"){
          this.glassTypes.push(item)
        }
      })
    },

    async getWuJianInFo() {
      let {data: res} = await this.$axios.post('bus/datasource/getWuJianInFo');
      if (res.code !== 0) {
        this.$message.error('获取【物件信息】失败')
        return;
      }
      this.wuJianNames = res.data;
    },

    async getDayChart() {
      if (!this.dayBad.dateDay){
        this.dayBad.dateDay = this.getDateFormat()
      }
      this.dayBadLoading = true
      this.dayBad.wujian_id = this.wuJianId
      this.dayBad.field = this.supplier
      let {data: res} = await this.$axios.post('bus/shouRuBoLi/dayChart',this.dayBad);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }
      if (res.data.XDay) {
        this.optionDayBad.xAxis[0].data = res.data.XDay
        this.optionDayBad.series[0].data = res.data.badNum
        this.optionDayBad.series[1].data = res.data.badPercent
        let a = this.$common.getDivisor(Math.max(...res.data.badNum))
        this.optionDayBad.yAxis[0].max = Math.ceil(Math.max(...res.data.badNum)/a)*a
        this.optionDayBad.yAxis[0].interval = Math.round(this.optionDayBad.yAxis[0].max/5*100)/100
       /* this.optionDayBad.yAxis[1].max = Math.max(...res.data.badPercent) + 5
        this.optionDayBad.yAxis[1].interval = Math.round(this.optionDayBad.yAxis[1].max/5*100)/100*/
      }
      this.renderEcharts('dayBad',this.optionDayBad)

      this.dayBadLoading = false
    },

    async getBlendChart() {
      this.blendChartLoading = true
      if (!this.glassTypeBad.year){
        this.glassTypeBad.year = this.$common.getCurrentYearByMonth().toString()
      }
      this.glassTypeBad.wujian_id = this.wuJianId
      this.glassTypeBad.field1 = this.supplier
      let {data: res} = await this.$axios.post('bus/shouRuBoLi/blendChart',this.glassTypeBad);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }
      if (res.data.XMonth) {
        this.optionBlend.xAxis[0].data = res.data.XMonth
        this.optionBlend.series[0].data = res.data.badNumTwo
        if (res.data[this.glassTypeBad.year - 1] && res.data[this.glassTypeBad.year]) {
          for (let i = 0; i < 3; i++) {
            this.optionBlend.series[1].data.push(res.data[this.glassTypeBad.year - 1])
          }
          for (let i = 3; i < this.optionBlend.xAxis[0].data.length; i++) {
            this.optionBlend.series[1].data.push(res.data[this.glassTypeBad.year])
          }
        }
        this.optionBlend.series[2].data = res.data.badPercent
        let a = this.$common.getDivisor(Math.max(...res.data.badNumTwo))
        this.optionBlend.yAxis[0].max = Math.ceil(Math.max(...res.data.badNumTwo)/a)*a
        this.optionBlend.yAxis[0].interval = Math.round(this.optionBlend.yAxis[0].max/5*100)/100
       /* this.optionBlend.yAxis[1].max = Math.max(Math.max(...res.data.badPercent),this.blendTarget) + 5
        this.optionBlend.yAxis[1].interval = Math.round(this.optionBlend.yAxis[1].max/5*100)/100*/
      }
      this.renderEcharts('blend',this.optionBlend)

      this.blendChartLoading = false
    },

    async getSupplierChart() {
      this.supplierChartLoading = true
      if (!this.supplierBad.year){
        this.supplierBad.year = this.$common.getCurrentYearByMonth().toString()
      }
      this.supplierBad.wujian_id = this.wuJianId
      let {data: res} = await this.$axios.post('bus/shouRuBoLi/supplierChart',this.supplierBad);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }else {
        this.optionSupplier.xAxis[0].data = res.data.XMonth
        this.optionSupplier.series[0].data = res.data.badNum
        this.optionSupplier.series[1].data = res.data.badNumTwo
        if (res.data[this.supplierBad.year-1] && res.data[this.supplierBad.year]) {
          for (let i = 0; i < 3; i++) {
            this.optionSupplier.series[2].data.push(res.data[this.supplierBad.year - 1])
          }
          for (let i = 3; i < res.data.XMonth.length; i++) {
            this.optionSupplier.series[2].data.push(res.data[this.supplierBad.year])
          }
        }
        this.optionSupplier.series[3].data = res.data.badPercent
        let a = this.$common.getDivisor(Math.max(...res.data.badNum))
        this.optionSupplier.yAxis[0].max = Math.ceil(Math.max(...res.data.badNum)/a)*a
        this.optionSupplier.yAxis[0].interval = Math.round(this.optionSupplier.yAxis[0].max/5*100)/100
        /*this.optionSupplier.yAxis[1].max = Math.max(Math.max(...res.data.badPercent),this.supplierTarget) + 5
        this.optionSupplier.yAxis[1].interval = Math.round(this.optionSupplier.yAxis[1].max/5*100)/100*/
        this.renderEcharts('supplier', this.optionSupplier)
      }

      this.supplierChartLoading = false
    },

    async getWuJianChart() {
      this.wuJianChartLoading = true
      await this.getSuppliers()
      this.wujianQuery.wujian_id = this.wuJianId
      this.wujianQuery.field = this.supplier
      let {data: res} = await this.$axios.post('bus/shouRuBoLi/wuJianChart',this.wujianQuery);
      if (res.code !== 0) {
        this.$message.error(res.message)
        this.optionWuJian.series[0].data = null
        this.optionWuJian.series[1].data = null
        this.optionWuJian.series[2].data = null
        this.optionWuJian.series[3].data = []
        this.optionWuJian.series[4].data = null
        this.wuJianChartLoading = false
      }
      if (res.data) {
        this.optionWuJian.xAxis[0].data = res.data.XMonth
        this.optionWuJian.series[0].data = res.data.series[0].data
        this.optionWuJian.series[1].data = res.data.series[1].data
        this.optionWuJian.series[2].data = res.data.series[2].data
        if (res.data.targets) {
          this.optionWuJian.series[3].data = res.data.targets
        }
        this.optionWuJian.series[4].data = res.data.series[3].data
        let a = this.$common.getDivisor(Math.max(...res.data.series[0].data))
        this.optionWuJian.yAxis[0].max = Math.ceil(Math.max(...res.data.series[0].data)/a)*a
        this.optionWuJian.yAxis[0].interval = Math.round(this.optionWuJian.yAxis[0].max/5*100)/100
        /*this.optionWuJian.yAxis[1].max = Math.max(Math.max(...res.data.badPercent),this.wuJianTarget) + 5
        this.optionWuJian.yAxis[1].interval = Math.round(this.optionWuJian.yAxis[1].max/5*100)/100*/
        this.optionWuJian.dataZoom[0].start = Math.max((this.optionWuJian.xAxis[0].data.length - 4),0) * 100 / this.optionWuJian.xAxis[0].data.length
        this.optionWuJian.dataZoom[0].end = 100
      }
      this.renderEcharts('wuJian',this.optionWuJian)

      this.wuJianChartLoading = false
    },

    /*async getWuJianChartData(params) {
      let range
      if (params.batch){
        range = params.batch[0]
      }else {
        range = params
      }
      this.wuJianChartLoading = true
      let query = {
        wuJianId:this.wuJianId,
        start:Math.floor(this.optionWuJian.xAxis[0].data.length * range.start/100),
        end:Math.ceil(this.optionWuJian.xAxis[0].data.length * range.end/100),
      }
      let {data: res} = await this.$axios.post('bus/shouRuBoLi/wuJianChart',JSON.stringify(query));
      if (res.code !== 0) {
        this.$message.error(res.message)
        this.wuJianChartLoading = false
      }else {
        if (res.data.XMonth) {
          this.optionWuJian.xAxis[0].data = res.data.XMonth
          this.optionWuJian.series[0].data = res.data.badNum
          this.optionWuJian.series[1].data = res.data.badNumTwo
          this.optionWuJian.series[2].data = res.data.selfReproach
          for (let i = 0; i < this.optionWuJian.xAxis[0].data.length; i++) {
            this.optionWuJian.series[3].data.push(this.wuJianTarget)
          }
          this.optionWuJian.series[4].data = res.data.badPercent
          let a = this.$common.getDivisor(Math.max(...res.data.badNum))
          this.optionWuJian.yAxis[0].max = Math.ceil(Math.max(...res.data.badNum)/a)*a
          this.optionWuJian.yAxis[0].interval = Math.round(this.optionWuJian.yAxis[0].max/5*100)/100
          /!*this.optionWuJian.yAxis[1].max = Math.max(Math.max(...res.data.badPercent),this.wuJianTarget) + 5
          this.optionWuJian.yAxis[1].interval = Math.round(this.optionWuJian.yAxis[1].max/5*100)/100*!/
          this.optionWuJian.dataZoom[0].start = range.start
          this.optionWuJian.dataZoom[0].end = range.end
        }
        this.renderEcharts('wuJian',this.optionWuJian)
      }
      this.wuJianChartLoading = false
    },*/

    async getPieChart() {
      if (!this.pieDate.year){
        this.pieDate.year =  this.$common.getCurrentYearByMonth().toString()
      }
      this.pieChartLoading = true
      this.pieDate.wujian_id = this.wuJianId
      this.pieDate.field1 = this.supplier
      let {data: res} = await this.$axios.post('bus/shouRuBoLi/pieChart',this.pieDate);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }
      this.optionPie.legend.data = res.data
      this.optionPie.series[0].data = res.data
      this.optionPie.title.text = "合计\n" + this.$common.getPieSum(this.optionPie.series[0].data)
      this.renderEcharts('pie',this.optionPie)

      this.pieChartLoading = false
    },

    async getDrumChart() {
      if (!this.drumDate.year){
        this.drumDate.year =  this.$common.getCurrentYearByMonth().toString()
      }
      this.drumChartLoading = true
      this.drumDate.wujian_id = this.wuJianId
      this.drumDate.field1 = this.supplier
      let {data: res} = await this.$axios.post('bus/shouRuBoLi/drumChart',this.drumDate);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }
      if (res.data) {
        this.optionDrum.xAxis[0].data = res.data.XDay
        res.data.drumSeries.unshift({name:'全部',type:'bar',stack:'check_item',data:[]})
        this.optionDrum.series = res.data.drumSeries
        this.optionDrum.legend.data = res.data.drumSeries
        this.renderEcharts('drumBoli', this.optionDrum)
      }

      this.drumChartLoading = false
    },

    async getClassDrumChart() {
      if (!this.classDate.year){
        this.classDate.year =  this.$common.getCurrentYearByMonth().toString()
      }
      this.classChartLoading = true
      this.classDate.wujian_id = this.wuJianId
      this.classDate.field = this.supplier
      let {data: res} = await this.$axios.post('bus/shouRuBoLi/classDrumChart',this.classDate);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }
      if (res.data) {
        this.optionClassDrum.xAxis[0].data = res.data.XDay
        this.optionClassDrum.series = res.data.drumSeries
        this.optionClassDrum.legend.data = res.data.drumSeries
        this.renderEcharts('classBl', this.optionClassDrum)
      }

      this.classChartLoading = false
    },

    async getReproachChart(){
      this.reproachChartLoading = true
      if (!this.reproach.year){
        this.reproach.year = this.$common.getCurrentYearByMonth().toString()
      }
      this.reproach.wujian_id = this.wuJianId
      this.reproach.field = this.supplier
      let {data: res} = await this.$axios.post('bus/shouRuBoLi/reproachChart',this.reproach);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }else {
        this.optionReproach.xAxis[0].data = res.data.XMonth
        let a = this.$common.getDivisor(Math.max(...res.data.selfReproach) + Math.max(...res.data.otherReproach))
        this.optionReproach.yAxis[0].max = Math.ceil((Math.max(...res.data.selfReproach) + Math.max(...res.data.otherReproach))/a)*a
        this.optionReproach.yAxis[0].interval = Math.round(this.optionReproach.yAxis[0].max/5*100)/100
        this.optionReproach.series[1].data = res.data.selfReproach
        this.optionReproach.series[0].data = res.data.otherReproach
        this.renderEcharts("selfReproach",this.optionReproach)
      }

      this.reproachChartLoading = false
    },

    /*async getTargetDict() {
      let {data: res} = await this.$axios.post('bus/datasource/getDictList','home_page');
      if (res.code !== 0) {
        this.$message.error('获取目标值失败')
        return;
      }
      res.data.forEach((item)=>{
        if (item.id === "shouru_boli_blend"){
          this.blendTarget = item.name
        }
        if (item.id === "shouru_boli_wujian"){
          this.wuJianTarget = item.name
        }
        if (item.id === "shouru_boli_supplier"){
          this.supplierTarget = item.name
        }
      })
    },*/
  },

  created() {
    this.getMaxHeight()
    this.getGlassTypeDict()
    this.getWuJianInFo()
    this.getSuppliers()
  },

  mounted() {
    this.renderAllEcharts()
  }
}
</script>

<style scoped>

.topContainer{
  display: flex;
  flex-direction: row;
}

.pageContainer{
  display: flex;
  flex-direction: row;
  overflow: hidden;
  width: 100%;
}

.space-between{
  display: flex;
  flex-direction: row;
  align-items: center;;
}

.asideContainer{
  width: 50%;
  height: 1200px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
}

.wujian_size{
  width: 940px;
  height: 200px
}

.chartSize{
  width: 470px;
  height: 190px
}

.summary{
  height: 190px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.messageCard{
  width: 100px;
  height: 65px;
  background-color:whitesmoke;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

margin-right{
  margin-right: 5px;
}

.message{
  color: whitesmoke;
  border-radius: 5px;
}

.outSideContainer{
  display: flex;
  align-items: center;
}

.bottomContainer{
  height: 400px;
}

.title{
  border-left: 3px solid steelblue;
  height: 25px;
  width: 80%;
  font-size: 16px;
  margin-left: 40px;
}
</style>